var waitForJQueryScripts = setInterval(function () {
    if (typeof $ != 'undefined') {


      

    /*** Back to Top Button ***/
    let backToTop2 = $("#backToTop");
    if ($(window).scrollTop() > 300) { 
        backToTop2.removeClass("hidden");
    
    } 
    $(window).on("scroll", () => {
        if ($(window).scrollTop() < 300) {
            backToTop2.fadeOut(500, () => {
                backToTop2.addClass("hidden");
            });
        } else {
            backToTop2.fadeIn(500);
            backToTop2.removeClass("hidden");
        }
    });
    backToTop2.on("click", () => {
        $('html, body').animate({ scrollTop:0 }, '300');
    });

    /*** Tablet Menu ***/
    $('.site-nav__icons .tablet--drop').click(function (e){
        e.stopPropagation();
        $('.tablet-menu-dropdown').toggleClass('open');
        $(this).toggleClass('open');
        $('.announcement-bar.below').toggleClass('disable');
    });

    $('.tablet-menu-dropdown .site-nav--has-dropdown').click(function(){
        $(this).toggleClass('open');
        $(this).find('.site-nav__dropdown').toggle(); 
        $('.tablet-menu-dropdown .site-nav--has-dropdown').not(this).removeClass('open').find('.site-nav__dropdown').hide();
    });

    /*** Mobile Menu ***/
    $('.js-drawer-open-nav').on("click", function(){
        $(this).toggleClass('open');
        $('.mobile-menu-drawer').toggle();
        $('.announcement-bar').toggleClass('hide');
        $('#SiteHeader').toggleClass('mobile-open');
        $('body').toggleClass('locked');
    });

    var previousTarget = null;
    $('.mobile-menu-drawer .site-nav__item').on("click", function(){
        $(this).find('.site-nav__dropdown').toggle();
        $(this).removeClass('inactive');
        $(this).toggleClass('open').siblings().removeClass('open').addClass('inactive').find('.site-nav__dropdown').hide();
        if (this === previousTarget) {
            $(this).siblings().removeClass('inactive');
        }
        previousTarget = this;
        return false;
    });

    $('.mobile-menu-drawer .site-nav__item:not(.site-nav--has-dropdown) a').on("click", function(e){
        e.stopPropagation();
    });

    $('.mobile-menu-drawer .site-nav__item.site-nav--has-dropdown .h5').on("click", function(e){
        e.stopPropagation();
        $(this).next('.grid__item-container').toggle();
        $(this).closest('.split-list').find('.split-item').toggle();
        $(this).toggleClass('active');
    });

    $(window).resize(function() {
        if($(this).width() >= 1066){
            $('.site-nav--has-dropdown').mouseover(function(){$('.site-header').addClass('active');});
            $('.site-nav--has-dropdown').mouseout(function(){$('.site-header').removeClass('active');});
        } else if($(this).width() <= 1066){
            
        }
        
        if($(this).width() >= 768){
            $('.mobile-menu-drawer').hide();
            $('.js-drawer-open-nav').removeClass('open');
            $('.site-header').removeClass('mobile-open');
        } else if($(this).width() <= 768){
            
        }
    });

    // Collection Filters
    $(".collection-filter__item--drawer button").click(function() {
        $('html,body').animate({scrollTop: $("#FilterDrawer.drawer--is-open").offset().top}, 'slow');
    });

    // Collection Moble Menu
    $('.ch-mobile-navigation-button').click(function(){
        $('.ch-sub-navigation').slideToggle();
        $(this).toggleClass('open');
    });

    function cshSubHeader(){
        if ($('.csh-carousel').length > 0) {
        $('.csh-carousel').flickity({
            imagesLoaded: true,
            percentPosition: true,
            freeScroll: true,
            wrapAround: true,
            cellAlign: 'left',
            contain: true,
            watchCSS: true
        });
    }
    } cshSubHeader();

    if (Shopify.designMode){
        document.addEventListener('shopify:section:load', function(){
            if(event.detail.sectionId === '{{ section.id }}') {
                cshSubHeader();
            }
        });
    }

    /*** Product variants ***/
    $('.variant-input-wrap.size').each(function() {
        if($(this).find('.variant-input').length == 1){
            $(this).addClass('single');
        } else if($(this).find('.variant-input').length == 2){
            $(this).addClass('double');
        } else {
            $(this).removeClass('single double');
        }
    });

    /*** Cart Drawer Item Count ***/

     //update item count in cart drawer on ajax product add
     $(document).on('ajaxProduct:added', function(evt) {
        var Cart;
        jQuery.getJSON('/cart.js').done(function(cart) {
            // now have access to Shopify cart object
            Cart = cart;
         //find if there are any of this item type already in cart
            let alreadyInCart = Cart.items.find(element => element.sku == evt.detail.product.sku);
            let totalItems;
            //if any already in cart, subtract that from quantity 
            alreadyInCart == undefined ? totalItems = (Cart.item_count + evt.detail.product.quantity) : totalItems = (Cart.item_count + evt.detail.product.quantity) - alreadyInCart.quantity;
            //handle 1 ITEM vs many ITEMS
            totalItems == 1 ? $('.cart__item-count').text(totalItems + " Item") : $('.cart__item-count').text(totalItems + " Items");
         });
    });

    //update item count in cart drawer on ajax cart update
    $(document).on('cart:updated', function(evt) {
        //grab cart
        Cart = evt.detail.cart;
        //handle 1 ITEM vs many ITEMS
        evt.detail.cart.item_count == 1 ? $('.cart__item-count').text(evt.detail.cart.item_count + " Item") : $('.cart__item-count').text(evt.detail.cart.item_count + " Items");
    });

    if ($('.wbp-full-carousel .product__main-photos').length > 0) {
        let checkProductCarousel = () => {
            if ($(window).width() >= 1500) {
            var margin = ($(window).width() - 1500) / 2;
            $('.wbp-full-carousel .product__main-photos').css('margin-left', margin + "px");
            } else if ($(window).width() < 1500 && $('.wbp-full-carousel .product__main-photos').css('margin-left') != '0px') {
                $('.wbp-full-carousel .product__main-photos').css('margin-left', "0px");
            }
        }; checkProductCarousel();
    
        $(window).on('resize', function() {
            checkProductCarousel();
        });
        }
      

      class FlickPatch {  //  Flick Carousel ARIA-HIDDEN observer
    constructor(document, selector) {
        this.document = document; this.selector = selector;
        this.sliders = [];
    }
    init() {
        this.sliders = Array.from( this.document.querySelectorAll( this.selector ));
      console.log(this.sliders);
        if( this.sliders.length ){
            this.sliders.forEach((slider) => {
                const mutationObserver = new MutationObserver(() => {
                    if(flickPatch && typeof flickPatch.removeAttr === "function") {
                        flickPatch.removeAttr(slider);
                    }
                });
                mutationObserver.observe(slider, { attributes: true, childList: true, subtree: true });
                this.removeAttr(slider);
            })            
        }
        return this;
    }
    removeAttr(slider) {
        const threshold = 0.1;
        if(slider) {
            [...slider.querySelectorAll(".carousel__slide, .grid__item, .slider-thumbnail-container, .carousel-cell, .slideshow__slide")].forEach((slide) => {
                var rect = slide.getBoundingClientRect();
                const overlap = rect.width * threshold;
                var viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth);
                if (!(rect.right < 0 + overlap || rect.left >= viewWidth - overlap)) {
                    if(slide.getAttribute("aria-hidden")) {
                        slide.removeAttribute("aria-hidden")
                    }
                } else {
                    if(!slide.getAttribute("aria-hidden")) {
                        slide.setAttribute("aria-hidden", "true")
                    }
                }
            })
        }
    }
}
//. Usage
let flickPatch = {}
    flickPatch = new FlickPatch(document, ".flickity-slider")
    flickPatch.init();

    $(".product-slideshow-full").each(function(){
        if($(this).find('.flickity-slider .product-main-slide').length <= 2){
            $(this).addClass('under');
        }    
    });
$(document).on('click', function (e){
    if ($(e.target).closest("#search-dropdown").length === 0) {
        $('.site-header__search-container, .search-overlay').removeClass('is-active');
        // $('.site-nav__item').removeClass('transparent');
    }
});
        clearInterval(waitForJQueryScripts);
    }
}, 10);


